import * as yup from 'yup';

export const AddJobSchema = (t: any) =>
  yup.object({
    title: yup.string().required(t('formErrors.required')),
    enterpriseDescription: yup.string().nullable(),
    jobDescription: yup.string().required(t('formErrors.required')),
    functionDescription: yup.string().nullable(),
    offerDescription: yup.string().nullable(),
    teaser: yup.string().nullable(),
    companyWebsiteUrl: yup
      .string()
      .nullable()
      .url(t('formErrors.invalidUrl'))
      .test('is-valid-url', t('formErrors.invalidUrl'), function (value) {
        if (!value) return true; // Allow empty values since it's optional
        try {
          const url = new URL(value);
          return url.protocol === 'http:' || url.protocol === 'https:';
        } catch {
          return false;
        }
      }),
    employmentTypes: yup
      .array()
      .min(1, 'Select at least one option of your interest'),
  });
